import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { UserDepositBonusModel, UserProfileModel, WSChatMessage, WSStatsMessage } from 'mvppoker-portal-common/api'
import { RootState } from '../AppStore'
import { addChatMessage, setLastUnreadChat, setReadChat, updateLobbyChat, addLobbyChatMessage, updateLobbyStats } from '../reducers/ProfileDataReducer'

export const useDepositBonus = () : UserDepositBonusModel | undefined =>
{
	return useSelector((root: RootState) => root.profileData.depositBonus)
}

export const useOtherProfilesLookup = () : { [userId: string] : UserProfileModel } =>
{
	return useSelector((root: RootState) => root.profileData.otherProfilesLookup)
}

export const useChats = () =>
{
	const dispatch = useDispatch()
	const chats = useSelector((root: RootState) => root.profileData.chats)

	const addMessage = useCallback(
		(userId: string, message: WSChatMessage, fromUser: boolean) => {
			dispatch(addChatMessage([userId, message, fromUser]))
		},
		[dispatch],
	)

	return { chats, addChatMessage: addMessage }
}

export const useLastUnreadChat = () =>
{
	const dispatch = useDispatch()
	const lastUnreadChat = useSelector((root: RootState) => root.profileData.lastUnreadChat)

	const update = useCallback(
		(message: WSChatMessage | undefined) => {
			dispatch(setLastUnreadChat(message))
		},
		[dispatch],
	)

	return { lastUnreadChat, setLastUnreadChat: update }
}
export const useHasUnreadChat = () =>
{
	return useSelector((root: RootState) => root.profileData.hasUnreadChat)
}
export const useUnreadChats = () =>
{
	const dispatch = useDispatch()
	const unreadChats = useSelector((root: RootState) => root.profileData.unreadChats)

	const update = useCallback(
		(userId: string) => {
			dispatch(setReadChat(userId))
		},
		[dispatch],
	)

	return { unreadChats, setReadChat: update }
}

export const useLobbyChat = () =>
{
	const dispatch = useDispatch()
	const lobbyChat = useSelector((root: RootState) => root.profileData.lobbyChat)
	// const hasUnreadLobbyChat = useSelector((root: RootState) => root.profileData.hasUnreadLobbyChat)

	const update = useCallback(
		(chat: WSChatMessage[]) => {
			dispatch(updateLobbyChat(chat))
		},
		[dispatch],
	)
	const addMessage = useCallback(
		(message: WSChatMessage) => {
			dispatch(addLobbyChatMessage(message))
		},
		[dispatch],
	)
	// const setRead = useCallback(
	// 	() => {
	// 		dispatch(setLobbyChatRead())
	// 	},
	// 	[dispatch],
	// )
	return { lobbyChat, /* hasUnreadLobbyChat, setGameChatRead: setRead, */ updateLobbyChat: update, addLobbyChatMessage: addMessage }
}

export const useLobbyStats = () =>
{
	const dispatch = useDispatch()
	const lobbyStats = useSelector((root: RootState) => root.profileData.lobbyStats)

	const update = useCallback(
		(stats: WSStatsMessage) => {
			dispatch(updateLobbyStats(stats))
		},
		[dispatch],
	)
	return { lobbyStats, updateLobbyStats: update }
}